/// <reference types="vite/client" />
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { SSRDataContext } from "./contexts/SSRDataContext";
import { readInitialData } from "./lib/ssrInitialData";
import "./index.css";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
  });
}

const rootEl = document.getElementById("root")!;

// Provide SSR-fetched data to components during hydration so initial
// client render matches the server-rendered HTML and avoids mismatches.
// The server embeds inert JSON so production CSP need not allow inline code.
const ssrInitialData = readInitialData();

const tree = (
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
      <SSRDataContext.Provider value={ssrInitialData}>
        <HelmetProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </SSRDataContext.Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If the page was prerendered, the root element will contain markup
// already — hydrate it. Otherwise (e.g. dev mode, or a non-prerendered
// route falling back to dist/index.html), do a fresh client render.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
